import { Menu, MenuHeader, MenuItem } from "@szhsin/react-menu";
import * as React from "react";
import { FunctionComponent } from "react";
import { AuthUser, getPlayerDisplayName } from "@mancala/core";
import { useTranslation } from "react-i18next";
import { Context } from "../../context/context";
import { getInitials } from "../../util/PlayerText";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css"

// Guests can log in or sign up; logged in users can log out.
const AccountMenu: FunctionComponent<{ context: Context, authUser: AuthUser }> = ({ context, authUser }) => {
    const { t } = useTranslation();
    const authService = context.authService;
    const name = getPlayerDisplayName(authUser, t);
    const menuButton = ({ open }: { open: boolean }) => (
        <button className={"ibtn" + (open ? " on" : "")} aria-label={`${t("Account")}: ${name}`} title={name}>
            <span className="me-av">{getInitials(name, authUser.isGuest)}</span>
        </button>
    );
    const menuItems = authUser.isGuest ? [
        <MenuItem key="login" onClick={() => authService.login()}>{t("LogIn")}</MenuItem>,
        <MenuItem key="signup" onClick={() => authService.signUp()}>{t("SignUp")}</MenuItem>,
    ] : [
        <MenuItem key="logout" onClick={() => authService.logout()}>{t("LogOut")}</MenuItem>,
    ];
    return (
        <Menu menuButton={menuButton} transition align="end" offsetY={8}>
            <MenuHeader>{name}</MenuHeader>
            {menuItems}
        </Menu>
    );
}

export default AccountMenu;
